import Cookies from "js-cookie";


export const getToken = (TokenKey: string) => {
    return Cookies.get(TokenKey);
};


export const setToken = (TokenKey: string, token: string) => {
    return Cookies.set(TokenKey, token);
};

